enum OwnershipEnum {
  FeeSimple = 'Fee Simple',
  GroundLease = 'Ground Lease',
}

export default OwnershipEnum;
